import PropTypes from 'prop-types';
import { useState , useEffect } from 'react';
// @mui
import { styled } from '@mui/material/styles';
import { List, Box, ListSubheader } from '@mui/material';
//
import { NavListRoot } from './NavList';

// ----------------------------------------------------------------------

export const ListSubheaderStyle = styled((props) => <ListSubheader   disableSticky disableGutters {...props} />)(
  ({ theme }) => ({
    ...theme.typography.overline,
    paddingTop: theme.spacing(3),
    paddingLeft: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    color: theme.palette.text.primary,
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shorter,
    }),
  })
);

// ----------------------------------------------------------------------

NavSectionVertical.propTypes = {
  isCollapse: PropTypes.bool,
  navConfig: PropTypes.array,
};

export default function NavSectionVertical({ navConfig,IsProfile, isCollapse = false, ...other }) {
  const str1 = localStorage.getItem("userMenu");
  const [str, setStr] = useState(str1);
  useEffect(()=>{
    if(str1 && str1!==''){
      const str2 = localStorage.getItem("userMenu");
      setStr(str2);
    }
  },[]);

  // console.log(navConfig,'navConfig5t45',str1)
  const MenuObj = JSON.parse(str);
  const [ListOfMenus, setListOfMenus] = useState([]);

   const mylist = [];
   useEffect(() => {
    if(navConfig && navConfig.length > 0){
      const sortedObject = navConfig.map((talent) =>
        {
          // items
          const sortedData = talent.items && talent.items.length > 0 ? talent.items.map((item) =>
            {
              // title
              const myData = MenuObj && MenuObj.length > 0 ? MenuObj.map((key) =>
              {
                // title
                if(key.menu_name === item.title){
                  console.log(key,item,'myData43',IsProfile)
                  if(key.menu_name !== 'Profile'){
                    mylist.push(item);
                  }
                  // if(IsProfile === 'Yes' && key.menu_name !== 'Profile'){
                  //   mylist.push(item);
                  // }
                  // mylist.push(item);
                }
                return key;
              }
              ):[];
              return item;
            }
            ):[];
          return talent;
        }
        );
        setListOfMenus(mylist);
    }
   },[navConfig]);

 console.log(ListOfMenus,'ListOfMenus67457')

  return (
    <Box {...other} >
      {/* {navConfig.map((group) => (
        <List  className="mainTitle" key={group.subheader} disablePadding sx={{ px: 2 }}>
          <ListSubheaderStyle
           
            sx={{
              
              ...(isCollapse && {
                opacity: 0,
                
                
              }),
            }}
          >
            {group.subheader}
        
          </ListSubheaderStyle >

          {group.items.map((list) => (
            <NavListRoot  className="profileTitle"  key={list.title} list={list} isCollapse={isCollapse} />
          ))}

        </List>
      ))} */}

       <List  className="mainTitle"  disablePadding sx={{ px: 2,mb:5 }}>
          <ListSubheaderStyle
           
            sx={{
              
              ...(isCollapse && {
                opacity: 0,
                
                
              }),
            }}
          >
            {/* {group.subheader} */}
          </ListSubheaderStyle >
          {ListOfMenus.map((list) => (
            <NavListRoot  className="profileTitle"  key={list.title} list={list} isCollapse={isCollapse} />
          ))}
        </List>
    </Box>
  );
}
